import { SetUpServiceData } from '@pages/AdditionalServices/containers/methods/basket/types';
import { OrderProductType, ServiceProductType } from '@services/requests/orderService/interface';
import { OrderProduct } from '@services/requests/orderService/orderProductsLoader/interface';
import { RouteResult } from '@services/requests/orderService/types';
import { CurrencyData } from '@services/requests/searchLoaders/currencyLoader/CurrencyLoaderQuery';
import { TFunction } from 'i18next';

/**
 * Получение названия группы товаров
 * @param type
 * @return string
 */
export const getProductNameByType = (type: OrderProductType): string => {
  switch (type) {
    case 'route':
      return 'CartComponent:Delivery';
  }
};

// ToDo
//  Создать единый способ группировки доп. услуг в корзине и детализации.
//  Вывести для них заголовок.
//  Прописать типизацию объекта с группой доп услуг из одной секции

export const getSectionServiceName = (
  products: OrderProduct[],
  t: TFunction<string[], undefined>,
  langId: string
) => {
  let sectionName = t(getProductNameByType(products[0].product_type));
  if (products[0].product_type !== 'route') {
    const serviceSection = JSON.parse(products[0].data);
    const serviceType: ServiceProductType = Array.isArray(serviceSection)
      ? serviceSection[0].type
      : serviceSection.type;

    if (serviceType === 'customs-payments') {
      sectionName = t('CustomsPayments:CustomsPayments');
    } else {
      const serviceSectionNames = Array.isArray(serviceSection)
        ? JSON.parse(serviceSection[0].data).sectionName
        : serviceSection.sectionName;

      sectionName =
        serviceSectionNames.localized_names.find((m) => m.lang_id === langId)?.message ||
        serviceSectionNames.name;
    }
  }
  return sectionName;
};

export const getCurrencyFromProduct = (
  products: OrderProduct[],
  currencies: CurrencyData[]
): CurrencyData | null => {
  if (products.length === 0 || currencies.length === 0) {
    return null;
  }

  const rootOrderProduct = products[0];

  switch (rootOrderProduct.product_type) {
    case 'route':
      const routeData: RouteResult = JSON.parse(rootOrderProduct.data);
      return currencies.find((currency) => currency.id === routeData.currencyId);
    case 'service':
      const simpleServiceData: SetUpServiceData = JSON.parse(rootOrderProduct.data);
      if (!simpleServiceData?.IsSetupService) {
        return null;
      }
      return currencies.find(
        (currency) => currency.id === simpleServiceData.service.currency_id.toString()
      );
    case 'complex':
      const complexServiceData: SetUpServiceData = JSON.parse(
        JSON.parse(rootOrderProduct.data)?.[0]?.data
      );

      if (!complexServiceData?.IsSetupService) {
        return null;
      }
      return currencies.find(
        (currency) => currency.id === complexServiceData.service.currency_id.toString()
      );
    default:
      return null;
  }
};
